/* unplugin-vue-components disabled */import { render } from "./SvgIconCalculatorWithBooks.vue?vue&type=template&id=046b2e00"
import script from "./SvgIconCalculatorWithBooks.vue?vue&type=script&lang=js"
export * from "./SvgIconCalculatorWithBooks.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__